import Component from "@glimmer/component"

interface Signature {
  Args: {
    offset: string
    target: string
    targetAttachment?: string
    attachment?: any
    class?: string
    constraints?: any
    closeMenu: () => void
  }
  Blocks: {
    default?: any
  }
}

export default class DSDropdownContainer extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "DS::DropdownMenuContainer": typeof DSDropdownContainer
  }
}
